import i18n from "@Shared/i18n";
import { MORTGAGE_COMPOUNDING_PERIOD, MORTGAGE_FREQUENCY } from "@Shared/@Types/application/application-enums";
export function formatVal(val) {
  return val.toLocaleString();
}
export function roundPen(val, decs) {
  if (val <= 0) return 0;
  const fact = 10 ** decs;
  return Math.round(val * fact) / fact;
}
export function roundReg(n) {
  return roundPen(n, 2);
}
export const focusField = name => {
  $("[name='" + name + "']").trigger("focus");
};
export function isValidItem(val, min, max, keyname, name, msg, formater) {
  min = Number(min);
  max = Number(max);
  if (val >= min && val <= max) return "";
  if (msg) msg = i18n.t(msg).toString();else msg = i18n.t(keyname).toString() + ": " + i18n.t("financial-tools.message_missing_questionRange").toString() + formater(min) + ", " + formater(max) + "]";
  focusField(name);
  return msg;
}
export function getInterestCompoundingFrequency(interestCompundFrequencyDd) {
  return interestCompundFrequencyDd == MORTGAGE_COMPOUNDING_PERIOD.MONTHLY ? 12 : 2;
}
export function getPaymentsPerYear(paymentFrequencyDd) {
  var _map$paymentFrequency;
  const map = {
    [MORTGAGE_FREQUENCY.MONTHLY]: 12,
    [MORTGAGE_FREQUENCY.SEMI_MONTHLY]: 24,
    [MORTGAGE_FREQUENCY.BIWEEKLY]: 26,
    [MORTGAGE_FREQUENCY.ACCELERATED_BIWEEKLY]: 26,
    [MORTGAGE_FREQUENCY.WEEKLY]: 52,
    [MORTGAGE_FREQUENCY.ACCELERATED_WEEKLY]: 52
  };
  return (_map$paymentFrequency = map[paymentFrequencyDd]) != null ? _map$paymentFrequency : 12;
}
export function calcPay(mortgage, amort, intrate, compoundin, freqNum, freqType) {
  const compound = compoundin / 12;
  const yrRate = intrate / compoundin;
  const rdefine = Math.pow(1.0 + yrRate, compound) - 1.0;
  const paymentCalcd = mortgage * rdefine * Math.pow(1.0 + rdefine, amort) / (Math.pow(1.0 + rdefine, amort) - 1.0);
  if (freqType === MORTGAGE_FREQUENCY.MONTHLY) {
    return paymentCalcd;
  } else if (freqType === MORTGAGE_FREQUENCY.BIWEEKLY || freqType === MORTGAGE_FREQUENCY.WEEKLY || freqType === MORTGAGE_FREQUENCY.SEMI_MONTHLY) {
    const amortYrsOnly = Math.floor(amort / 12);
    const amortMonthsOnly = amort % 12;
    const compound2 = compoundin / freqNum;
    const monTime2 = amortYrsOnly * freqNum + amortMonthsOnly * 2;
    const rdefine2 = Math.pow(1.0 + yrRate, compound2) - 1.0;
    return mortgage * rdefine2 * Math.pow(1.0 + rdefine2, monTime2) / (Math.pow(1.0 + rdefine2, monTime2) - 1.0);
  } else if (freqType === MORTGAGE_FREQUENCY.ACCELERATED_BIWEEKLY) {
    return paymentCalcd / 2.0;
  } else if (freqType === MORTGAGE_FREQUENCY.ACCELERATED_WEEKLY) {
    return paymentCalcd / 4.0;
  }
  return paymentCalcd;
}